import { all, call } from 'redux-saga/effects';
import { routinePromiseWatcherSaga } from 'redux-saga-routines';
import user from './user';
import publisher from './publisher';
import managed from './managed';
import soundcast from './soundcast';
import episode from './episode';
import rating from './rating';
export default function* () {
  yield all([
    call(user),
    call(publisher),
    call(managed),
    call(soundcast),
    call(episode),
    call(rating),
    call(routinePromiseWatcherSaga),
  ]);
}
